/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiChannelRuleFromJSON, ApiChannelRuleToJSON, } from './ApiChannelRule';
export function ApiChannelGroupFromJSON(json) {
    return ApiChannelGroupFromJSONTyped(json, false);
}
export function ApiChannelGroupFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'rules': !exists(json, 'rules') ? undefined : (json['rules'].map(ApiChannelRuleFromJSON)),
    };
}
export function ApiChannelGroupToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'rules': value.rules === undefined ? undefined : (value.rules.map(ApiChannelRuleToJSON)),
    };
}
